'use client'

import { useModals, useSearchParams } from '@/lib/hooks'
import type React from 'react'

import { SMSReceipt } from '@/components/forms'
import { Dialog, DialogContent } from '@/components/ui'

interface SMSReceiptModalProps extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const SMSReceiptModal = ({ open }: SMSReceiptModalProps) => {
  const { closeModal } = useModals()
  const { orderId } = useSearchParams()

  return (
    <Dialog open={open}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('SMS_RECEIPT')}
        size="md"
        className="min-h-[200px]"
      >
        <SMSReceipt orderId={orderId} />
      </DialogContent>
    </Dialog>
  )
}
